module.exports = {
      id: "cinema-usage",
      viewBox: "0 0 26.501 25.377",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#cinema",
      toString: function () {
        return this.url;
      }
    }